var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between ts-mb-3"},[_c('h1',{staticClass:"page-header ts-mb-0"},[_vm._v(_vm._s(_vm.$t('bankV2.editTitle')))]),_c('ts-breadcrumb',{attrs:{"items":[
        { text: _vm.$t('toHomePage'), href: '/' },
        { text: _vm.$t('bankV2.breadcrumb'), href: '/v2/payment/banks' },
        { text: _vm.$t('bankV2.editTitle'), active: true }
      ]}})],1),_c('bank-form',{attrs:{"mode":"edit","bank-id":_vm.$route.params.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }